import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LanguageService {
    private readonly LANG_KEY = 'app_lang';

    constructor(private translate: TranslateService) {}

    init() {
        const savedLang = localStorage.getItem(this.LANG_KEY);

        const lang = savedLang || 'fr';

        this.translate.setDefaultLang('fr');
        this.use(lang);
    }

    use(lang: string) {
        this.translate.use(lang);
        localStorage.setItem(this.LANG_KEY, lang);
    }

    getCurrentLang(): string {
        return this.translate.currentLang || 'fr';
    }
}
